export const SORT_BY = {
  TITLE: 'TITLE',
  STATUS: 'STATUS',
  SCHEDULE: 'SCHEDULE',
  ACTIVITY: 'ACTIVITY',
  PRIORITY: 'PRIORITY'
};

export const LIMIT = 20;
